/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../controls.module.ts" />


module Meevo.Components.Controls {
    "use strict";

    //interface ICompiledExpression {
    //    (context: any, locals?: any): any;

    //    // If value is not provided, undefined is gonna be used since the implementation
    //    // does not check the parameter. Let's force a value for consistency. If consumer
    //    // whants to undefine it, pass the undefined value explicitly.
    //    assign(context: any, value: any): any;
    //}


    //interface IParseService {
    //    (expression: string): ICompiledExpression;
    //}
    import securityKeys = Meevo.Components.Common.SecurityKeys;

    export class MeevoProfileMenu implements angular.IDirective {

        restrict = "E";
        scope = {
            show: "="
        };

        templateUrl = "app/components/controls/profileMenu/profileMenuTemplate.html";

        constructor(private identityService: Meevo.Components.Common.IdentityService,
            private dataService: Meevo.Components.Common.ICommonDataService,
            private $window: angular.IWindowService,
            private modalService: Meevo.Components.Modal.IModalService,
            private printService: Meevo.Components.Common.IPrintService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected $rootScope: ng.IRootScopeService,
            protected securityService: Meevo.Components.Common.ISecurityService
        ) {

        }

        link = (scope: any, element: JQuery, attr: angular.IAttributes) => {
            scope.alertsCount = null;

            scope.identityService = this.identityService;

            const refreshPrinterList = () => {
                this.printService.getPrinterList().then((printerList) => {
                    scope.printerList = printerList;
                    this.printService.getSelectedPrinter().then(printer => scope.receiptPrinter = printer);
                });
            }

            refreshPrinterList();

            scope.$on(Meevo.Components.Common.Messages.POS_HARDWARE_UPDATED, (event, args, params) => {
                refreshPrinterList();
            });

            let uri = `/${this.appSettings.API_ROOT}/Settings/HelpDeskTicket`;
            this.dataService.customMethodData(uri, 'get', {}).then((data) => {
                scope.showLiveChatMenu = data.data.liveChatSupport;
                scope.showSalesForceHelpDeskTicket = data.data.salesforceSupport;
           });
            angular.element('body').on('click', function ($event) {
                if (!($($event.target).hasClass("not-collapse"))) {
                    scope.$apply(function () {
                        scope.show = false;
                    });
                }
            });


            scope.closeUserMenu = () => {
                scope.show = false;
            }

            scope.receiptPrinterChanged = () => {
                if (!scope.receiptPrinter) {
                    return;
                }
                
                this.printService.setSelectedPrinter(scope.receiptPrinter);
                let isSystemPrinterGuid = (new Guid(scope.receiptPrinter.id.toString())).equals(Guid.empty);
                let request = {
                    lastUsedPrinterId: isSystemPrinterGuid ? null : scope.receiptPrinter.id.toString()
                    , clearLastUsedPrinter: isSystemPrinterGuid
                };
                this.dataService.customMethodData("api/session/DrawerPreferences", "PATCH", request);
            }

            scope.$on(Components.Common.Messages.PRINTER_SELECTED, (event, args, params) => {
                scope.receiptPrinter = _.findWhere(scope.printerList, { id: params.id });
            });

            scope.sessionLockout = () => {
                if (this.identityService.current().restrictedAccess) {
                    this.modalService.alert("MESSAGE_LOCKOUT_IN_IP_RESTRICTED", 0, true);
                }
                else {
                    this.$rootScope.$broadcast(Meevo.Components.Common.Messages.SESSION_TIMEOUT_HANDLER, Meevo.Model.SessionState.Lockout, 'MeevoProfileMenu');
                }
            }

            scope.logout = () => {
                this.dataService.logout().then((response: any) => {
                    let url = this.identityService.current().sessionTimeoutRedirectUrl;
                    this.identityService.setIdentity(null);
                    this.$window.onbeforeunload = () => null;
                    this.$window.location.href = url;
                });
            }

            scope.changePassword = () => {
                let options: Meevo.Components.Modal.IModalOptions = {
                    templateUrl: "app/components/changePassword/changePassword.html",
                    locals: {
                        model: null,
                        userId: this.identityService.current().userId,
                        userName: this.identityService.current().userAuthName,
                        requireChangePassword: null
                    },
                    controller: "meevo.changePassword.ChangePasswordController",
                    controllerAs: "changePassword",
                    bindToController: true
                }

                this.modalService.showCustom(options).then((result) => {

                });

            }

            scope.viewProviderProfile = () => {
                let endpoint: string = this.appSettings.ROUTE_NAMES.profileSettings;
                // Build params for editing promo
                let stateParams = {
                    targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                    actionState: Meevo.Model.MaintenanceFormState.Editing,
                    id: this.identityService.current().userId
                };
                this.$rootScope.$broadcast("gotoState",
                    {
                        stateName: endpoint,
                        stateParams: stateParams
                    });
            }

            scope.securityKeys = securityKeys;

            scope.submitHelpdeskTicket = () => {
                var params = {
                    userName: this.identityService.current().userAuthName,
                    subject: 'Meevo 2 Ticket'
                };
                let userId = this.identityService.current().userId;
                let uri = `/${this.appSettings.API_ROOT}/ProfileSettings/${userId}/HelpdeskTicket`;
                this.dataService.customMethodData(uri, 'GET', null, params).then((result) => {
                    if (!result.data.isSalesforceSupportEnabled) {
                        this.modalService.alert("Salesforce support must be enabled in Business Information > Preferences.");
                        return;
                    }
                    let helpdeskTicketUrl = result.data.salesforceSupportTicket;
                    let supportTicketTab = this.$window.open(helpdeskTicketUrl, '_blank');
                    if (!supportTicketTab || supportTicketTab.closed || typeof supportTicketTab.closed == 'undefined') {
                        //  WHEN POPUP BLOCKED
                        this.modalService.alert('Cannot naviagte to SalesForce support site. Browser Pop-ups are blocked.');
                        console.log('Cannot open SalesForce support ticket');
                    }
                })

            }

            scope.goToAlertsLog = ($event) => {
                $event.stopPropagation(); // in order to block event viewProviderProfile()
                scope.show = false;
                // todo: dev
                this.$rootScope.$broadcast('gotoState', {
                    stateName: this.appSettings.ROUTE_NAMES.alertsLog,
                    stateParams: {
                        showNewAlerts: scope.alertsCount > 0
                    }
                });
            }

            scope.startSupportSession = () => {
                let screenConnectBase = this.identityService.current().systemSettings.screenConnectBase;
                scope.sessionCode = scope.sessionCode ? scope.sessionCode : '';
                let screenConnectURI = screenConnectBase + scope.sessionCode

                let supportTicketTab = Model.Guard.isSomething(screenConnectBase) ? this.$window.open(screenConnectURI, '_blank') : null;

                scope.sessionCode = null;
            }

            var liveChatSupportUrlWindow;
            scope.startLiveChat = () => {
                var params = {
                    userName: this.identityService.current().userAuthName,
                    subject: 'Meevo 2 Chat'
                };
                let userId = this.identityService.current().userId;
                let uri = `/${this.appSettings.API_ROOT}/ProfileSettings/${userId}/LiveChatSupport`;

                this.dataService.customMethodData(uri, 'GET', null, params).then((result) => {
                    if (!result.data.isLiveChatSupportEnabled) {
                            this.modalService.alert("Live Chat support must be enabled in Business Information > Preferences.");
                        return;
                    }
                    let liveChatSupportUrl = result.data.liveChatSupportUrl;
                    if (liveChatSupportUrlWindow && !liveChatSupportUrlWindow.closed && liveChatSupportUrlWindow.location) {
                        liveChatSupportUrlWindow.location.href = liveChatSupportUrl;
                        liveChatSupportUrlWindow.focus();
                    } else {

                        liveChatSupportUrlWindow = open(liveChatSupportUrl, "LiveChatSupport", "location=1,status=1,width=460,height=510,resizable=0");
                    }

                    /***  TODO: Cross Window Communication to keep session alive    ***/
                    if (!liveChatSupportUrlWindow || liveChatSupportUrlWindow.closed || typeof liveChatSupportUrlWindow.closed == 'undefined') {
                        //  WHEN POPUP BLOCKED
                        //this.modalService.alert('Unable to open live chat support. Browser Pop-ups are blocked.');
                    }
                })
            }

            scope.$watch('show', (newValue: boolean, oldValue: boolean) => {
                if (newValue && this.securityService.hasSecurity(securityKeys.MANAGEMENT_ALERTSLOG + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                    scope.getAlertsCount();
                }
            });

            scope.getAlertsCount = () => {
                this.dataService.customMethodData('api/alertLogDetail/Count', 'POST', {
                    criteria: {
                        triggeredToUserId: this.identityService.current().userId
                    }
                }).then(response => {
                    scope.alertsCount = response.data;
                });
            }
        }

        static factory(): angular.IDirectiveFactory {
            let directive = (identityService: Meevo.Components.Common.IdentityService,
                dataService: Meevo.Components.Common.ICommonDataService,
                $window: angular.IWindowService,
                modalService: Meevo.Components.Modal.IModalService,
                printService: Meevo.Components.Common.IPrintService,
                appSettings: Meevo.Components.Common.IAppSettings,
                $rootScope: ng.IRootScopeService,
                securityService: Meevo.Components.Common.ISecurityService
            ) => {
                return new MeevoProfileMenu(identityService, dataService, $window, modalService, printService, appSettings, $rootScope, securityService);
            };

            directive.$inject = ["meevo.components.common.IdentityService",
                "meevo.components.common.DataService",
                "$window",
                "meevo.components.modal.ModalService",
                "meevo.components.common.PrintService",
                "meevo.AppSettings",
                "$rootScope",
                "meevo.components.common.SecurityService"
            ];

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoProfileMenu", MeevoProfileMenu.factory());
}